import { isDomainEntityId } from '@salsita-ai/platform-project-sdk/domain';
import { stackComponent, stackItemComponent } from './stack-component.js';
import { isStackValid } from './stack.js';
const cache = new WeakMap();
export class StackProjections {
    _componentReader;
    constructor(_componentReader){
        this._componentReader = _componentReader;
    }
    getStacks(state) {
        const cached = cache.get(state);
        if (cached) {
            return cached;
        }
        const stackItemComponents = this._componentReader.readManyComponents({
            componentTypes: [
                stackItemComponent
            ]
        }, state);
        const stackComponents = this._componentReader.readManyComponents({
            componentTypes: [
                stackComponent
            ]
        }, state);
        const stackItemsByStackMap = new Map();
        const stackItems = new Map();
        for (const stackItem of stackItemComponents){
            if (!stackItemsByStackMap.has(stackItem.state.stackKey)) {
                stackItemsByStackMap.set(stackItem.state.stackKey, []);
            }
            if (!isDomainEntityId(stackItem.componentInstance.entityId)) {
                throw new Error(`Stack item ${stackItem.componentInstance.entityId} is not a valid domain entity id!`);
            }
            if (stackItems.has(stackItem.componentInstance.entityId)) {
                throw new Error(`Stack item ${stackItem.componentInstance.entityId} is already in the stack! Entity can be only in one stack.`);
            }
            const item = {
                id: stackItem.componentInstance.entityId,
                x: stackItem.state.x,
                width: stackItem.state.width,
                stackKey: stackItem.state.stackKey,
                componentInstance: stackItem.componentInstance
            };
            stackItems.set(stackItem.componentInstance.entityId, item);
            stackItemsByStackMap.get(stackItem.state.stackKey).push(item);
        }
        const stacks = stackComponents.map((stack)=>{
            const stackItems = stackItemsByStackMap.get(stack.state.stackKey) ?? [];
            if (!stackItems) {
                throw new Error(`Stack ${stack.state.stackKey} has no stack items!`);
            }
            return {
                stackKey: stack.state.stackKey,
                parentEntityId: stack.state.parentEntityId,
                limits: {
                    min: stack.state.min,
                    max: stack.state.max
                },
                items: stackItems,
                componentInstance: stack.componentInstance
            };
        });
        const result = {
            stacks,
            stackItems
        };
        cache.set(state, result);
        return result;
    }
    getStack(stackKey, state) {
        const { stacks } = this.getStacks(state);
        const stack = stacks.find((stack)=>stack.stackKey === stackKey);
        if (!stack) {
            throw new Error(`Stack ${stackKey} not found, cannot get stack! Make sure the stack exists and has a valid stackId.`);
        }
        return stack;
    }
    areStacksValid(state) {
        const { stacks } = this.getStacks(state);
        return stacks.every((stack)=>isStackValid(stack.items, stack.limits));
    }
    isStackValid(stackKey, state) {
        const stack = this.getStack(stackKey, state);
        if (!stack) {
            throw new Error(`Stack ${stackKey} not found, cannot validate stack! Make sure the stack exists and has a valid stackId.`);
        }
        return isStackValid(stack.items, stack.limits);
    }
    getStackItem(id, state) {
        const { stackItems } = this.getStacks(state);
        const item = stackItems.get(id);
        if (!item) {
            throw new Error(`Stack item ${id} not found, cannot get stack item! Make sure the stack item exists.`);
        }
        return item;
    }
}

//# sourceMappingURL=stack-projections.js.map